// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] || chunkId) + "-" + {"245":"87c4d66453ce6a0fb0db","453":"1a4423cf0919b4aa66b5","522":"fbac7d0789a0bf567d25"}[chunkId] + ".js";
};